'use client';

import classNames from 'classnames';
import { useMemo } from 'react';

import { useMounted } from '@shared/utils/hooks/use-mounted';

import styles from './profile-picture-placeholder.module.scss';

type ProfilePicturePlaceholderProps = {
  firstName: string;
  lastName: string;
};

export const ProfilePicturePlaceholder = ({
  firstName,
  lastName,
}: ProfilePicturePlaceholderProps) => {
  const initials = `${firstName?.[0] || ''}${lastName?.[0] || ''}`.toUpperCase();

  const size = 120;
  const theme = useMemo(() => (Math.floor(Math.random() * 5) + 1) as 1 | 2 | 3 | 4 | 5, []);
  const isMounted = useMounted();

  if (!isMounted) {
    return null;
  }

  return (
    <svg
      height={size}
      viewBox={`0 0 ${size} ${size}`}
      width={size}
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle
        className={classNames(styles['placeholder__container'], {
          [styles[`placeholder__container--${theme}`]]: theme,
        })}
        cx={size / 2}
        cy={size / 2}
        r={size / 2}
      />
      <text className={styles['placeholder__text']} x="50%" y="54%">
        {initials}
      </text>
    </svg>
  );
};
